/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TxService } from '../shared/tx.service';
import { HelperService } from '../helper/helper.service';
import { AccountService } from '../user/account.service';
import { tap } from 'rxjs/operators';
import { ApiErrorService } from '../api-error.service';
import { HotelSearchRequest } from 'src/app/models/hotel-booking/search-request';
import { DatePipe } from '@angular/common';
import { PaymentIntentResponse } from 'src/app/models/payment';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';
import { Location, PlatformLocation } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class HotelBookingService {
  apiParams: any;

  constructor(
    private httpClient: SmartHttpService,
    private envService: TxService,
    private helperService: HelperService,
    private accountService: AccountService,
    private apiErrorService: ApiErrorService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private localStorageData: LocalStorageService,
    private location: Location,
    private platformLocation: PlatformLocation
  ) {
    this.initApiParams();
  }
  public get getHotelSearchQuery() {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.HOTEL_SEARCH_QUERY)
    );
  }
  public get getHotelPriceInfo() {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.HOTEL_PRICE_INFO)
    );
  }
  public get getHotelGuestInfo() {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.HOTEL_GUEST_INFO)
    );
  }
  public get hotelSearchServiceApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.hotelSearchServiceApi = `${this.envService.gethotelSearchApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get hotelReviewServiceApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.hotelReviewServiceApi = `${this.envService.getHotelReviewApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get hotelDetailServiceApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.hotelDetailServiceApi = `${this.envService.getHotelDetailsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get hotelBookServiceApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.hotelBookServiceApi = `${this.envService.getCreateBookingApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get getBookingDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.getBookingDetailApi = `${this.envService.getHotelBookingApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get appPageApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.appPageApi = `${this.envService.getAppPageApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public get addUserActionApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.addUserActionApi = `${this.envService.addUserActionApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get hotelCancelBookingApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.hotelCancelBookingApi = `${this.envService.getHotelCancelBooking()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get bookHotelApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.bookHotelApi = `${this.envService.getbookHotelApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get hotelDealCustomReqAlert(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.hotelDealCustomReqAlert = `${this.envService.getHotelDealsCustomReqAlertApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set bookHotelApi(value: string) {}
  public set hotelCancelBookingApi(value: string) {}
  public set addUserActionApi(value: string) {}
  public set appPageApi(value: string) {}

  public set hotelSearchServiceApi(value: string) {}
  public set hotelDetailServiceApi(value: string) {}
  public set hotelReviewServiceApi(value: string) {}
  public set hotelBookServiceApi(value: string) {}
  public set getBookingDetailApi(value: string) {}
  public set hotelDealCustomReqAlert(value: string) {}

  public set setHotelPriceInfo(hotelPriceInfo: any) {
    this.localStorageData.setItem(
      localStorageKeys.HOTEL_PRICE_INFO,
      JSON.stringify(hotelPriceInfo)
    );
  }
  public set setHotelGuestInfo(hotelGuestInfo: any) {
    this.localStorageData.setItem(
      localStorageKeys.HOTEL_GUEST_INFO,
      JSON.stringify(hotelGuestInfo)
    );
  }

  public set checkBookingStatusApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get checkBookingStatusApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.checkBookingStatusApi = `${this.envService.checkHotelBookingStatusApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set getHotelBookingHistoryApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get getHotelBookingHistoryApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.checkBookingStatusApi = `${this.envService.getHotelBookingHistoryApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public saveSearchQuery(object: HotelSearchRequest) {
    if (
      JSON.parse(
        this.localStorageData.getItem(localStorageKeys.HOTEL_GUEST_INFO)
      )
    ) {
      this.localStorageData.removeItem(localStorageKeys.HOTEL_GUEST_INFO);
    }
    this.localStorageData.setItem(
      localStorageKeys.HOTEL_SEARCH_QUERY,
      JSON.stringify(object)
    );
  }

  public getSearchQuery(): HotelSearchRequest {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.HOTEL_SEARCH_QUERY)
    ) as HotelSearchRequest;
  }

  public saveHotelDealSearchQuery(object: HotelSearchRequest) {
    if (
      JSON.parse(
        this.localStorageData.getItem(localStorageKeys.HOTEL_GUEST_INFO)
      )
    ) {
      this.localStorageData.removeItem(localStorageKeys.HOTEL_GUEST_INFO);
    }
    this.localStorageData.setItem(
      localStorageKeys.HOTEL_DEAL_SEARCH_QUERY,
      JSON.stringify(object)
    );
  }

  public getHotelDealSearchQuery(): HotelSearchRequest {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.HOTEL_DEAL_SEARCH_QUERY)
    ) as HotelSearchRequest;
  }

  public removeHotelPriceInfo() {
    this.localStorageData.removeItem(localStorageKeys.HOTEL_PRICE_INFO);
  }
  public removeHotelGuestInfo() {
    this.localStorageData.removeItem(localStorageKeys.HOTEL_GUEST_INFO);
  }

  initApiParams() {
    this.apiParams = {};
  }

  getCityHotelSuggestions(query: string, page?: number): Observable<any> {
    this.initApiParams();
    this.apiParams.q = query?.trim() || '';
    this.apiParams.page = page || 0;
    return this.httpClient.get(this.hotelSearchServiceApi);
  }

  getHotelReview(
    bookingId,
    requestId
  ): Observable<any> {
    this.apiParams.bookingCode = bookingId;
    if (requestId) {
      this.apiParams.requestId = requestId;
    }
    return this.httpClient.get<any>(this.hotelReviewServiceApi);
  }

  getHotelDealCustomReqAlert(): Observable<any> {
    this.initApiParams();
    return this.httpClient.get(this.hotelDealCustomReqAlert);
  }

  public getDealcarousel(carouselId: number, page: number): Observable<any> {
    this.initApiParams();
    this.apiParams.carouselId = carouselId;
    this.apiParams.page = page || 1;
    return this.httpClient.get(this.appPageApi);
  }

  getHotelDetails(
    payload: HotelSearchRequest,
    offset = 0,
    sortBy = '',
  ): Observable<any> {
    if (payload.rt !== 'detailed' && payload.searchType !== 'deals') {
      this.saveSearchQuery(payload);
    }
    if(payload.rt !== 'detailed' && payload.searchType === 'deals'){
      this.saveHotelDealSearchQuery(payload);
    }
    this.apiParams.offset = offset;
    this.apiParams.sortby = sortBy;
    return this.httpClient.postWithErorrHandler<any>(
      this.hotelDetailServiceApi,
      payload
    );
  }
  sendHotelBookingEmail(bookingId: string): Observable<any> {
    this.initApiParams();
    this.apiParams.action_name = 'email_booking';
    this.apiParams.action_type = 'hotel_booking';
    this.apiParams.action_id = bookingId;
    return this.httpClient.get(this.addUserActionApi);
  }

  createBooking(
    bookingId: string,
    customerDetails: any,
    leadGuestDetail: any,
    totalFare: number,
    saveGuestData: number,
    requestId: string,
    campaignId:number,
    requestType?: string,
    checkinDate?: string,
    checkoutDate?: string,
    hotelType?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.saveGuest = saveGuestData;
    if (requestId) {
      this.apiParams.requestId = requestId;
    }
    if (campaignId) {
      this.apiParams.campaignId = campaignId;
    }
    if (requestType) {
      this.apiParams.requestType = requestType;
    }
    if(hotelType){
      this.apiParams.hotelType = hotelType;
    }
    const origin = location.origin;
    const path = this.location.path().split('?')[0]; // remove query params
    this.apiParams.redirect_url = origin + path;
    return this.httpClient.post<PaymentIntentResponse>(
      this.hotelBookServiceApi,
      {
        BookingCode: bookingId,
        ...customerDetails,
        TotalFare: totalFare,
        ...leadGuestDetail,
        BookingType: 'Voucher',
        PaymentMode: 'Limit',
        type: 'single',
        checkin: checkinDate,
        checkout: checkoutDate,
      }
    );
    // .pipe(
    //   tap((error: any) => {
    //     this.apiErrorService.updateValue(true);
    //   })
    // );
  }

  public getBookingDetail(
    bookingReferenceId: string,
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.bookingReferenceId = bookingReferenceId;
    return this.httpClient.get(this.getBookingDetailApi);
  }

  public cancelBooking(confirmationNumber: string): Observable<any> {
    this.initApiParams();
    this.apiParams.confirmationNumber = confirmationNumber;
    return this.httpClient.get(this.hotelCancelBookingApi);
  }

  bookHotel(
    paymentIntentId: string,
    paymentSessionId?: string
  ): Observable<any> {
    this.initApiParams();
    // this.apiParams.currency = 'USD';
    // this.apiParams.paymentIntentId = paymentIntentId;
    // this.apiParams.paymentSessionId = paymentSessionId;
    return this.httpClient.post<any>(
      this.bookHotelApi,
      {
        paymentIntentId: paymentIntentId,
        paymentSessionId: paymentSessionId,
      }
    );
  }

  public checkBookingStatusRequest(bookingId) {
    this.initApiParams();
    this.apiParams.bookingId = bookingId;
    return this.httpClient.get<any>(this.checkBookingStatusApi);
  }

  public getHotelBookingHistoryRequest(page, count) {
    this.initApiParams();
    this.apiParams.page = page;
    this.apiParams.count = count;
    return this.httpClient.get<any>(this.getHotelBookingHistoryApi);
  }

  public getHeaderString(searchQuery) {
    const { roomCount, guestCount } = this.getGuestRoomInfo(searchQuery);
    
    const guestText = guestCount === 1 
      ? this.translate.instant('hotel.hotel_search.guest')
      : this.translate.instant('hotel.hotel_search.guests');
    
    const roomText = roomCount === 1 
      ? this.translate.instant('hotel.hotel_search.room')
      : this.translate.instant('hotel.hotel_search.rooms');
    
    const checkin = searchQuery.checkin;
    const checkout = searchQuery.checkout;
    const hasDates = checkin && checkout;

    const dateText = hasDates
      ? `${this.datePipe.transform(checkin, 'd LLL')} - ${this.datePipe.transform(checkout, 'd LLL')}`
      : '';

    const guestRoomText = `${guestCount} ${guestText} | ${roomCount} ${roomText}`;

    return dateText ? `${dateText} | ${guestRoomText}` : guestRoomText;

  }

  public getGuestRoomInfo(searchQuery) {
    const roomCount = searchQuery.rooms.length;
    let guestCount = 0;
    searchQuery.rooms.forEach((item) => {
      guestCount += item.adults + item.children;
    });
    return {
      roomCount,
      guestCount,
      numberOfNights: this.getNumberOfNights(searchQuery),
    };
  }

  public getNumberOfNights(searchQuery) {
    if (searchQuery?.checkin && searchQuery?.checkout) {
      const date1 = new Date(searchQuery.checkin);
      const date2 = new Date(searchQuery.checkout);
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }
    return '';
  }
}
